/** In-memory Bearer fallback only (never persist). Prefer HttpOnly cookie. */
let sessionBearerToken = null;

export function setSessionBearerToken(token) {
  sessionBearerToken = token || null;
}

export function getSessionBearerToken() {
  return sessionBearerToken;
}

export function clearSessionBearerToken() {
  sessionBearerToken = null;
}

/** Persist login payload without the access token. */
export function persistAuthUserData(payload) {
  if (!payload) {
    localStorage.removeItem("userData");
    return;
  }
  const { token, ...rest } = payload;
  const safe = {
    ...rest,
    user: sanitizeStoredUser(rest.user),
  };
  localStorage.setItem("userData", JSON.stringify(safe));
  if (token) {
    setSessionBearerToken(token);
  }
}

/** Drop sensitive / unused keys if an older fat payload is still around. */
export function sanitizeStoredUser(user) {
  if (!user || typeof user !== "object") return user;

  const allow = new Set([
    "id",
    "name",
    "full_name",
    "salutation",
    "email",
    "phone",
    "contact_no",
    "type",
    "status",
    "email_verified",
    "unique_id",
    "college_id",
    "department_id",
    "designation_id",
    "designation_name",
    "profile_pic",
    "featured_img",
    "institute_id",
    "pan",
    "permissions",
    "cost_centers",
    "advance_ledger_codes",
    "has_advance_ledger",
    "advance_acc_ledger_code_id",
    "password_expires_at",
    "password_days_remaining",
    "password_force_change",
    "password_warn",
    "tfa_compulsory",
    "tfa_enabled",
    "tfa_channel",
    "tfa_active",
  ]);

  const out = {};
  Object.keys(user).forEach((key) => {
    if (allow.has(key)) out[key] = user[key];
  });

  if (Array.isArray(out.permissions)) {
    out.permissions = out.permissions.map((p) => ({
      id: p.id,
      name: p.name,
    }));
  }

  if (Array.isArray(out.cost_centers)) {
    out.cost_centers = out.cost_centers.map((c) => ({
      id: c.id,
      name: c.name,
      code: c.code ?? c.cost_center_code ?? c.revenue_center_code ?? null,
    }));
  }

  return out;
}

export function clearAuthUserData() {
  localStorage.removeItem("userData");
  localStorage.removeItem("lastAccess");
  localStorage.removeItem("otp_token");
  clearSessionBearerToken();
}

/** One-time migration: drop token + fat PII from localStorage. */
export function stripStoredAuthToken() {
  try {
    const raw = localStorage.getItem("userData");
    if (!raw) return;
    const data = JSON.parse(raw);
    if (!data) return;
    const { token, ...rest } = data;
    const safe = {
      ...rest,
      user: sanitizeStoredUser(rest.user),
    };
    localStorage.setItem("userData", JSON.stringify(safe));
  } catch (_) {
    /* ignore */
  }
}
